import { App, type ModalFuncProps } from 'antd';

import { DEFAULT_MODAL_OPTIONS } from '@/constants/modal.constants';

export function useModalMethod() {
  const { modal } = App.useApp();

  const confirm = (props?: ModalFuncProps) =>
    modal.confirm({
      transitionName: '',
      ...DEFAULT_MODAL_OPTIONS,
      ...props,
    });

  const error = (props?: ModalFuncProps) =>
    modal.error({
      title: '操作に失敗しました',
      okButtonProps: DEFAULT_MODAL_OPTIONS.okButtonProps,
      transitionName: '',
      ...props,
    });

  return { confirm, error };
}
